import React, { useEffect, useState } from "react";
import Select from "react-select";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

const AddStudent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    colleges: [],
    course: [],
    employees: [],
    status: "",
    comment: "",
  });

  const [errors, setErrors] = useState({});

  const [collegeOptions, setCollegeOptions] = useState([])

  const [courseOptions, setCourseOptions] = useState([])

  const [employeeOptions, setEmployeeOptions] = useState([])

  const [userRole, setUserRole] = useState(localStorage.getItem("userData"));
  const navigate = useNavigate()
  const location = useLocation()

  const managers = [
    { name: "Employee Manager", path: "/employee-manager" },
    { name: "Student Manager", path: "/student-manager" },
    { name: "NL & NC Student Manager", path: "/nl-nc-student-manager" },
    { name: "College Manager", path: "/college-manager" },
    { name: "Course Manager", path: "/course-manager" },
    { name: "Admission Manager", path: "/admission-manager" }
  ];

  const statusOptions = [
    { value: "pending", label: "Pending" },
    {value: "NeedsTime", label: "Needs time/ long follow up"},
    { value: "interested", label: "Interested" },
    { value: "connected", label: "Connected" },
    { value: "TakenAdmWithIn20Days", label: "Clg pitched need L3 follow up" },
    { value: "TakenAdmWithIn30Days", label: "Clg pitched std needs time" },
    { value: "willTakeAdmAfterExam", label: "Will take adm after examination" },
    { value: "NC", label: "NC" },
    { value: "lookingForNY", label: "Looking for NY" },
    { value: "Nl", label: "Nl" },
    { value: "CAF", label: "CAF" },
    { value: "walkIn", label: "Walk in" },
    { value: "walkInCompleted", label: "Walk in Completed" },
    { value: "seatBooked", label: "Seat Booked" },
    { value: "admissionSuccessful", label: "Admission Successful" },
    { value: "waitForWbjee", label: "Wait for WBJEE" },
    { value: "waitForJenpas", label: "Wait for JENPAS" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/all-colleges`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      })
      setCollegeOptions(response?.data?.data?.map((value) => { return { value: value?._id, label: value?.name } }));
    };
    fetchData();

    const fetchCourseData = async () => {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-all-courses`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      })
      setCourseOptions(response?.data?.users?.map((value) => { return { value: value?._id, label: value?.name } }));
    };
    fetchCourseData();
  }, []);
  useEffect(() => {
    if ((location.pathname === "/view-student" || location.pathname === "/edit-student") && !location.state) {
      navigate("/student-manager")
    }
    if (location?.state?.type === "view" || location?.state?.type === "edit") {
      setFormData({ ...location?.state?.data, colleges: location?.state?.data?.collegeDetail?.map((e) => { return { value: e?._id, label: e?.name } }), course: location?.state?.data?.courseDetail?.map((e) => { return { value: e?._id, label: e?.name } }), employees: location?.state?.data?.employeeDetail?.map((e) => { return { value: e?._id, label: e?.name } }) })
    }
  }, [location])
  useEffect(() => {
    if (localStorage.getItem("userData")) {
      let data = JSON.parse(localStorage.getItem("userData"))
      setUserRole(data)
      if (data?.role === "admin") {
        const fetchEmployeData = async () => {
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/sub-admin`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${localStorage.getItem("token")}`,
            },
          })
          setEmployeeOptions(response?.data?.users?.map((value) => { return { value: value?._id, label: value?.name } }));
        };
        fetchEmployeData();
      }
    }
  }, [])

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Student Name is required";
    else if (formData.email && formData.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format";

    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    else if (!/^\d{10}$/.test(formData.mobile))
      newErrors.mobile = "Enter a valid 10-digit mobile number";

    if (!formData.status) newErrors.status = "Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name !== "comment" && name !== "email" && name !== "address") {
      setErrors(prev => { return { ...prev, [name]: "" } });
    }
  };

  const handleMultiSelectChange = (selectedOptions, field) => {
    setFormData({ ...formData, [field]: selectedOptions || [] });
    if (field !== "employees") {
      setErrors(prev => { return { ...prev, [field]: "" } });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await axios.post(location?.state?.type !== "edit" ? `${process.env.REACT_APP_BASE_URL}/create-student` : `${process.env.REACT_APP_BASE_URL}/edit-student`, {
        ...formData, colleges: formData?.colleges?.map(e => e?.value),
        course: formData?.course?.map(e => e?.value), employees: formData?.employees?.map(e => e?.value), _id: location?.state?.data?._id
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      setFormData({
        name: "",
        email: "",
        mobile: "",
        address: "",
        colleges: [],
        course: [],
        employees: [],
        status: "",
        comment: "",
      });
      setErrors({});
      navigate("/student-manager")
    } catch (error) {
      console.error("Error adding student:", error);
      toast(error?.response?.data?.message)
    }
  };
  return (
    <div className="min-h-screen flex bg-gray-100">
      <ToastContainer />
      <Sidebar />
      <div className="flex-1 p-6">
        <h1 className="text-2xl font-bold mb-6">{location?.state?.type === "view" ? "View" : location?.state?.type === "edit" ? "Edit" : "Add"} Student</h1>
        <div className="bg-white shadow-md rounded-lg p-6">
          {/* Student Name */}
          <div className="mb-4">
            <label className="block font-bold mb-2">Student Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              disabled={location?.state?.type === "view"}
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-4 py-2 w-full"
              placeholder="Enter student name"
            />
            {errors.name && <p className="text-red-500">{errors.name}</p>}
          </div>

          {/* Email */}
          <div className="mb-4">
            <label className="block font-bold mb-2">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              disabled={location?.state?.type === "view"}
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-4 py-2 w-full"
              placeholder="Enter email"
            />
            {errors.email && <p className="text-red-500">{errors.email}</p>}
          </div>

          {/* Mobile */}
          <div className="mb-4">
            <label className="block font-bold mb-2">Mobile</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              disabled={location?.state?.type === "view"}
              className="border border-gray-300 rounded-md px-4 py-2 w-full"
              placeholder="Enter mobile number"
            />
            {errors.mobile && <p className="text-red-500">{errors.mobile}</p>}
          </div>

          {/* Address */}
          <div className="mb-4">
            <label className="block font-bold mb-2">Address</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              disabled={location?.state?.type === "view"}
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-4 py-2 w-full"
              placeholder="Enter address"
            />
          </div>

          {/* Colleges Multi-select */}
          <div className="mb-4">
            <label className="block font-bold mb-2">Colleges</label>
            <Select
              isMulti
              options={collegeOptions}
              value={formData.colleges}
              isDisabled={location?.state?.type === "view"}
              onChange={(selected) => handleMultiSelectChange(selected, "colleges")}
              className="border border-gray-300 rounded-md"
              placeholder="Select colleges"
            />
          </div>

          {/* Course Multi-select */}
          <div className="mb-4">
            <label className="block font-bold mb-2">Course</label>
            <Select
              isMulti
              options={courseOptions}
              value={formData.course}
              isDisabled={location?.state?.type === "view"}
              onChange={(selected) => handleMultiSelectChange(selected, "course")}
              className="border border-gray-300 rounded-md"
              placeholder="Select courses"
            />
          </div>

          {/* Assign Employee Multi-select */}
          {(userRole?.role === "admin") && <div className="mb-4">
            <label className="block font-bold mb-2">Assign Employee</label>
            <Select
              isMulti
              options={employeeOptions}
              value={formData.employees?.length > 0 && formData.employees}
              isDisabled={location?.state?.type === "view"}
              onChange={(selected) => handleMultiSelectChange(selected, "employees")}
              className="border border-gray-300 rounded-md"
              placeholder="Assign employees"
            />
          </div>}

          {/* Status Dropdown */}
          <div className="mb-4">
            <label className="block font-bold mb-2">Status</label>
            <select
              name="status"
              value={formData.status}
              disabled={location?.state?.type === "view"}
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-4 py-2 w-full"
            >
              <option value="" disabled>Select status</option>
              {statusOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {errors.status && <p className="text-red-500">{errors.status}</p>}
          </div>

          <div className="mb-4">
            <label className="block font-bold mb-2">Add Comment (Optional)</label>
            <textarea
              name="comment"
              value={formData.comment}
              disabled={location?.state?.type === "view"}
              onChange={handleChange}
              className="border border-gray-300 rounded-md px-4 py-2 w-full"
              placeholder="Enter any additional comments"
            />
          </div>

          {/* Submit Button */}
          {location?.state?.type !== "view" && <button onClick={handleSubmit} className="bg-blue text-white px-6 py-2 rounded-md shadow-md">
            Submit
          </button>}
        </div>
      </div>
    </div>
  );
};

export default AddStudent;
